// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3D9xg","toggleWrap":"styles_toggleWrap__2DqWi","content":"styles_content__3v6Mf","selectAreaCode":"styles_selectAreaCode__P5BqT"};